// extracted by mini-css-extract-plugin
module.exports = {"sumBlock":"SumRenderer_sumBlock__VnMFW"};